import React, { useState } from "react";
import PropTypes from "prop-types";

const InvitationStep2 = ({ step2Result }) => {
  const [password, setPassword] = useState("1234");
  const [passwordRe, setPasswordRe] = useState("1234");

  const handleSubmit = async () => {
    step2Result({ password: password });
  };

  return (
    <div>
      password {password}
      <br />
      password-re {passwordRe}
      <br />
      <button onClick={handleSubmit}>Submit</button>
    </div>
  );
};

InvitationStep2.propTypes = {
  step2Result: PropTypes.func,
};

export default InvitationStep2;
